<template>

    <b-container fluid  class="top-padding bottom-padding no-horiz-padding">

        <h1>Handweaving.net Subscription</h1>
        <div class='background-two' style='padding-bottom: 0.5rem; padding-top: 0.5rem;'>
        <div class="right-padding align-top small-vertical-padding border-box">

            <div v-if="isAuthenticated && !inPurchaseFlow">
                <div v-if='subscriptionStatus==="activeRenews"' class="small-vertical-padding">
                    Your {{ subscriptionType }} subscription is active and renews on {{subscriptionExpirationDate}}. Thanks for your support!
                </div>
                <div v-if='subscriptionStatus==="activeSingle"' class="small-vertical-padding">
                    Your subscription is active until {{subscriptionExpirationDate}}. Thanks for your support!
                </div>
                <div v-if='subscriptionStatus==="cancelled"' class="small-vertical-padding">
                    Your subscription is cancelled but you may still use it until {{subscriptionExpirationDate}}. Please consider subscribing again and thanks for supporting Handweaving.net!
                </div>
                <div v-if='subscriptionStatus==="expired"' class="small-vertical-padding">
                    Your subscription is expired. Please consider subscribing again and thanks for supporting Handweaving.net!
                </div>
            </div>

            <div v-if="!isAuthenticated">
                <span style='padding-right: 1.0rem'>
                    <login-control prompt='Subscribe Today' :show-as-link="false"/>
                </span>
                <span v-if='!showDiscount'>${{subscriptionMonthlyCost}}&nbsp;/&nbsp;month&nbsp;or&nbsp;</span>
                <span v-if='!showDiscount'>${{subscriptionAnnualCost}}&nbsp;/&nbsp;year</span>                    
                <span class='drawdown-green' v-if='showDiscount'><br/><br/>{{ discountPlanMessage }}</span>     
            </div>

            <div v-if="isAuthenticated && !inPurchaseFlow">

                <h2 v-if='!(subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")'>Choose&nbsp;Subscription</h2>

                <div class="small-bottom-padding" v-if='!(showDiscount || subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")'>
                    <b-button variant='primary' @click="beginSubscribe(false, false)">Monthly Subscription &raquo;</b-button>
                    ${{subscriptionMonthlyCost}}&nbsp;/&nbsp;month
                </div>

                <div class="small-bottom-padding" v-if='(subscriptionStatus == "activeRenews" && subscriptionType == "monthly")'>
                    <b-button variant='primary' @click="beginSubscribe(false, true)">Change Payment Method &raquo;</b-button>
                    ${{subscriptionMonthlyCost}}&nbsp;/&nbsp;month, {{subscriptionPaymentDetailsPrompt}}
                </div>

                <div v-if='!(subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")'>
                    <b-button variant='primary' @click="beginSubscribe(true, false)">Annual Subscription &raquo; &nbsp;</b-button>
                    <span v-if='!showDiscount'>${{subscriptionAnnualCost}}&nbsp;/&nbsp;year</span><span class='drawdown-green' v-if='showDiscount'><br/><br/>{{ discountPlanMessage }}</span>
                </div>

                <div v-if='(subscriptionStatus == "activeRenews" && subscriptionType == "annual")'>
                    <b-button variant='primary' @click="beginSubscribe(true, true)">Change Payment Method &raquo; &nbsp;</b-button>
                    ${{subscriptionAnnualCost}}&nbsp;/&nbsp;year, {{subscriptionPaymentDetailsPrompt}}
                </div>

                <div class='inline-auto-width' style='background-color: #ffffff;'><img style="max-width: 100%;" :src='getSiteImageUrl("tiny-paypal-logo.jpg")' /></div>
            </div>

            <div v-if='(!inPurchaseFlow && (subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle"))'>
                <a href="#" @click="handleCancelStarted">Cancel Subscription</a>
            </div>

            <div v-show='inPurchaseFlow && !isProcessing' style='padding-right: 25px' id="dropin-container"></div>
            <div v-show='isProcessing && !isUpdate'>Processing subscription...please wait</div>
            <div v-show='isProcessing && isUpdate'>Updating subscription...please wait</div>
            
            <div v-show='inPurchaseFlow' style='padding: 12px'>
                <button id='subscribe-submit-button' v-show='paymentMethodRequestable && isAuthenticated && subscribeButtonEnabled && inPurchaseFlow && !(subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")' @click='dropinRequestPaymentMethod' class="btn btn-primary">Confirm Subscription</button>
                <button id='subscribe-update-submit-button' v-show='paymentMethodRequestable && isAuthenticated && subscribeButtonEnabled && inPurchaseFlow && (subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")' @click='dropinRequestPaymentMethod' class="btn btn-primary">Update Payment Details</button>

                <span v-if="inPurchaseFlow && isAnnualPurchase && subscribeButtonEnabled">
                    <span v-if='!showDiscount'>${{subscriptionAnnualCost}} per year</span><span class='drawdown-green' v-if='showDiscount'>{{ discountPlanMessage }}</span>
                </span>
                <span v-if="inPurchaseFlow && !isAnnualPurchase && subscribeButtonEnabled">
                    ${{subscriptionMonthlyCost}} per month
                </span>

                <br v-if='paymentMethodRequestable && inPurchaseFlow && subscribeButtonEnabled' /><br v-if='paymentMethodRequestable && inPurchaseFlow' />

                <span class='dark-green-text italic-text' v-if='paymentMethodRequestable && isAuthenticated && subscribeButtonEnabled && inPurchaseFlow && !(subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")'>
                    <span class="dark-red-text">IMPORTANT: </span>Click
                    <font class="bold-text">Confirm Subscription</font> to finish subscribing after entering PayPal or a card.
                </span>
                <span class='dark-green-text italic-text' v-if='paymentMethodRequestable && isAuthenticated && subscribeButtonEnabled && inPurchaseFlow && (subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")'>
                    <span class="dark-red-text">IMPORTANT: </span>Click
                    <font class="bold-text">Update Payment Details</font> to change the method for your subscription after entering PayPal or a card.
                </span>

                <span class='italic-text' v-if='isAuthenticated && subscribeButtonEnabled && inPurchaseFlow && !(subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")'>
                    <br/><br/>Please
                    <router-link to="/contact">contact us</router-link> if you have questions or need help!
                </span>
                <span class='italic-text' v-if='isAuthenticated && subscribeButtonEnabled && inPurchaseFlow && (subscriptionStatus == "activeRenews" || subscriptionStatus == "activeSingle")'>
                    <br/><br/>Please
                    <router-link to="/contact">contact us</router-link> if you have questions or need help!
                </span>
            </div>

        </div>
        </div>

        <div class="top-padding background-one" style='margin-bottom: 1rem'>

            <div class="inline-auto-width align-top top-padding" style='padding-right: 2.5rem;'>
                <h2>What you get...</h2>
                <ul>
                    <li class="bottom-padding">View full drafts</li>
                    <li class="bottom-padding">Use all draft features</li>
                    <li class="bottom-padding">Download in WIF format</li>
                    <li class="bottom-padding">Straighten and turn</li>
                    <li class="bottom-padding">Choose tieup orientation</li>
                    <li class="bottom-padding">Change view size</li>
                    <li class="bottom-padding">Common threading search</li>
                    <li class="bottom-padding">Draft color editing</li>
                </ul>
            </div>
            <div style="vertical-align: top; padding-right: 2.0rem" class="inline-auto-width top-padding">
                <div style='margin-left: 0; padding-left:0' class="small-top-padding bottom-padding">With Subscription:</div>
                <img style="max-width: 100%;" :src='getSiteImageUrl("63611-small-7-tl.png")' />
            </div>
            <div style="vertical-align: top" class="inline-auto-width top-padding">
                <div style='margin-left: 0; padding-left:0' class="small-top-padding bottom-padding">Without Subscription:</div>
                <img style="max-width: 100%;" :src='getSiteImageUrl("63611-small-7-tl-d.png")' />
            </div>
        </div>

        <div class="top-padding background-two">
            
                <h2>About our subscriptions...</h2>
                
                <img class='embed-right' :src='getSiteImageUrl("iStock-1140111408-500.jpg")' />
                <p>
                    We use PayPal Braintree Payments, a safe and secure system where you can use either credit cards or PayPal, and your payment information is never stored on Handweaving.net.
                </p>
                <p>
                    Subscriptions begin on the subscription date, renewing each following calendar year or month on the same date unless you cancel before then.
                </p>
                <p>
                    You may cancel easily at any time by visiting your
                    <router-link to="/account">account page</router-link>. The cancellation occurs on your next renewal date, and your subscription remains in effect until then but does not renew.
                </p>
                <p>
                    We extend our sincere thanks to all site visitors and especially to our supporters! Without you, Handweaving.net would not exist.
                </p>
        </div>

        <div class="top-padding background-one">
        
            <h2>Terms and conditions...</h2>

            <img class='embed-right' :src='getSiteImageUrl("iStock-502752495-500.jpg")' />

            <ul>
                <li class='bottom-padding'>
                    <span class="bold-text">Renewal: </span>Subscriptions renew and are charged again at the end of each term until cancelled.</li>
                <li class='bottom-padding'>
                    <span class="bold-text">Cancellation:</span> Subscriptions may be cancelled at any time. No refunds are given and cancelled subscriptions remain usable until the next renewal date.</li>
                <li class='bottom-padding'>
                    <span class="bold-text">Usage:</span> Subscriptions may be used by the subscriber only and may not be shared by multiple people.</li>
                <li class='bottom-padding'>
                    <span class="bold-text">Availability:</span> We will make every reasonable effort to ensure Handweaving.net is available but have no specific guarantee of service. From 2015 until 2021, Handweaving.net had less than 7 hours of downtime.</li>
            </ul>
        </div>

        <div class="top-padding background-two">
            <h2>Free to all...</h2>
            
            <img class='embed-right' :src='getSiteImageUrl("iStock-1189025801-500.jpg")' />
            Some of Handweaving.net is freely available to all, even without a subscription:<br/><br/>
            <ul>
                <li class="bottom-padding">Ralph Griswold's Digital Archive (including document downloads)</li>
                <li class="bottom-padding">Drafts with drawdown views</li>
                <li class="bottom-padding">Basic accounts with clipboards</li>
            </ul>
        </div>


        <b-modal auto-focus-button='ok' ref='subConfirmCancelModalRef' title='Cancel Subscription?' ok-title='No, Keep My Subscription' @ok='handleModalCancelCancelled' cancel-title='Yes, Cancel Now ' @cancel='handleModalCancelConfirmed' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Are you sure you want to cancel your Handweaving.net subscription? Please use our Contact link if you need help or have feedback for us.
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='subCancelledModalRef' title='Subscription Cancelled' ok-title='Ok' @ok='handleModalCancelCompletedOk' ok-only :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Your subscription has been cancelled but you may still use it until the next renewal date. Thanks for your support and we hope you will return later!
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='subFailedModalRef' title='Subscription Not Completed' ok-title='Ok' @ok='handleModalFailedOk' ok-only :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Your subscription request could not be completed. Please try again with a different payment method.
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='cancelFailedModalRef' title='Subscription Not Completed' ok-title='Ok' @ok='handleModalCancelFailedOk' ok-only :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Your subscription cancellation request could not be completed. Please contact us for assistance.
            </div>
        </b-modal>

        <b-modal auto-focus-button='ok' ref='subSucceededModalRef' :title='isUpdate ? "Subscription Updated" : "Subscription Completed"' ok-title='Ok' @ok='handleModalSucceededOk' ok-only :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                <span v-if='isUpdate'>Your subscription was updated.</span>
                <span v-if='!isUpdate'>Thank you for subscribing!</span>
                Please sign in whenever you visit to get full subscriber benefits.
            </div>
        </b-modal>

    </b-container>
</template>

<script>
import dataService from '../mixins/dataService.js'
import mediaService from '../mixins/mediaService.js'
import utilityService from '../mixins/utilityService.js'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import loginControl from './LoginControl.vue'
import config from '../config/config.js'
import dropin from 'braintree-web-drop-in'

export default {
    data() {
        return {
            inPurchaseFlow: false,
            isAnnualPurchase: false,
            subscribeButtonEnabled: false,
            isUpdate: false,
            isProcessing: false,
            dropinInstance: null,
            paymentPayload: null,
            paymentMethodRequestable: false
        }
    },

    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        loginControl: loginControl
    },
    mixins: [dataService, mediaService, utilityService],

    methods: {
        beginSubscribe: function(isAnnual, isUpdate) {
            this.isAnnualPurchase = isAnnual
            this.isUpdate = isUpdate
            this.inPurchaseFlow = true
            this.subscribeButtonEnabled = false

            // https://braintree.github.io/braintree-web-drop-in/docs/current/#usage
            this.getBraintreeClientToken(this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                let token = resp.data

                if (!this.dropinInstance) {
                    dropin.create(
                        {
                            authorization: token,
                            selector: '#dropin-container',
                            paypal: {
                                flow: 'vault'
                            }
                        },
                        (err, newDropinInstance) => {
                            if (err) {
                                // Handle any errors that might've occurred when creating Drop-in
                                console.error(err)
                                return
                            }
                            this.dropinInstance = newDropinInstance

                            this.dropinInstance.on('paymentMethodRequestable', (event) => {
                                this.dropinPaymentMethodAvailable()
                            })

                            this.dropinInstance.on('noPaymentMethodRequestable', () => {
                                this.dropinPaymentMethodUnavailable()
                            })

                            this.subscribeButtonEnabled = true
                        }
                    )
                }
                else {
                    this.subscribeButtonEnabled = true
                }
            })
        },

        dropinRequestPaymentMethod() {
            this.dropinInstance.requestPaymentMethod((err, payload) => {
                if (err || !payload || !payload.nonce) {
                }
                else {
                    this.subscribeButtonEnabled = false
                    this.isProcessing = true
                    this.processSubscriptionWithNonce(payload.nonce)
                }
            })
        },

        dropinPaymentMethodAvailable() {
            this.paymentMethodRequestable = true
        },

        dropinPaymentMethodUnavailable() {
            this.paymentMethodRequestable = false
        },

        cancelSubscription: function() {
            this.removeSubscription(this.authUser.UserID, this.authUser.LoginToken)
                .then(retVal => {
                    if (retVal.success) {
                        this.handleCancelSuccess()
                    }
                    else {
                        this.handleCancelFailure()
                    }
                })
        },

        navigateToHome: function() {
            this.$router.push({ name: 'Home' })
        },

        processSubscriptionWithNonce: function(nonce) {
            let subscriptionType = this.isAnnualPurchase ? 'annual' : 'monthly'

            if (this.showDiscount && subscriptionType==='annual') {
                this.addOrUpdateSubscriptionDisc(this.authUser.UserID, this.authUser.LoginToken, subscriptionType, this.discountPlanID, nonce)
                    .then(retval => {
                        if (retval.success) {
                            this.handleSubscribeSuccess()
                        }
                        else {
                            this.isProcessing = false
                            this.handleSubscribeFailure()
                        }
                    })
            }
            else {
                this.addOrUpdateSubscription(this.authUser.UserID, this.authUser.LoginToken, subscriptionType, nonce)
                    .then(retval => {
                        if (retval.success) {
                            this.handleSubscribeSuccess()
                        }
                        else {
                            this.isProcessing = false
                            this.handleSubscribeFailure()
                        }
                    })
            }
        },

        showSubscriptionConfirmCancelDialog: function(isShow) {
            isShow ? this.$refs.subConfirmCancelModalRef.show() : this.$refs.subConfirmCancelModalRef.hide()
        },

        showSubscriptionCancelledDialog: function(isShow) {
            isShow ? this.$refs.subCancelledModalRef.show() : this.$refs.subCancelledModalRef.hide()
        },

        showSubscribeSuccessDialog: function(isShow) {
            isShow ? this.$refs.subSucceededModalRef.show() : this.$refs.subSucceededModalRef.hide()
        },
        showSubscribeFailedDialog: function(isShow) {
            isShow ? this.$refs.subFailedModalRef.show() : this.$refs.subFailedModalRef.hide()
        },
        showCancelFailedDialog: function(isShow) {
            isShow ? this.$refs.cancelFailedModalRef.show() : this.$refs.cancelFailedModalRef.hide()
        },

        handleSubscribeSuccess: function() {
            this.inPurchaseFlow = false
            // revalidate and reload logged in user to pick up the new subscription info added on the back end
            this.validateUser(this.authUser).then(resp => {
                let validatedUser = resp.data
                if (validatedUser) {
                    this.$store.commit('setAuthUser', validatedUser)
                    this.subscribeButtonEnabled = false
                    this.showSubscribeSuccessDialog(true)
                    this.isProcessing = false
                }
            })
        },

        handleSubscribeFailure: function() {
            this.inPurchaseFlow = false
            this.showSubscribeFailedDialog(true)
            this.subscribeButtonEnabled = true
            this.isProcessing = false
        },

        handleCancelFailure: function() {
            this.inPurchaseFlow = false
            this.showCancelFailedDialog(true)
        },

        // Cancel subscription clicked, show confirm dialog
        handleCancelStarted: function() {
            this.showSubscriptionConfirmCancelDialog(true)
        },

        // OK clicked in confirm cancel dialog
        handleModalCancelConfirmed: function() {
            this.showSubscriptionConfirmCancelDialog(false)
            this.cancelSubscription()
        },

        // Cancel clicked in confirm cancel dialog
        handleModalCancelCancelled: function() {
            this.showSubscriptionConfirmCancelDialog(false)
        },

         // Cancellation is completed, show cancelled dialog
        handleCancelCompleted: function() {
            this.showSubscriptionConfirmCancelDialog(false)
            this.showSubscriptionCancelledDialog(true)
        },

        // OK clicked in cancelled complete dialog
        handleModalCancelCompletedOk: function() {
            this.showSubscriptionCancelledDialog(false)
            this.navigateToHome()
        },

        handleCancelSuccess: function() {
            this.inPurchaseFlow = false
            // revalidate and reload logged in user to pick up the new subscription info removed on the back end
            this.validateUser(this.authUser).then(resp => {
                let validatedUser = resp.data
                if (validatedUser) {
                    this.$store.commit('setAuthUser', validatedUser)
                    this.handleCancelCompleted()
                }
            })
        },

        handleModalFailedOk: function() {
            this.showSubscribeFailedDialog(false)
        },

        handleModalCancelFailedOk: function() {
            this.showSubscriptionConfirmCancelDialog(false)
            this.showSubscriptionCancelledDialog(false)
            this.showSubscribeFailedDialog(false)
        },

        handleModalSucceededOk: function() {
            this.showSubscribeSuccessDialog(false)
            this.navigateToHome()
        }

    },
    computed: {
        authUser: function() {
            return this.$store.state.authUser
        },
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },
        subscriptionStatus: function() {
            return this.$store.state.authUser.SubscriptionStatus
        },
        subscriptionExpirationDate: function() {
            return this.$store.state.authUser.SubscriptionExpirationDate
        },
        subscriptionType: function() {
            return this.$store.state.authUser.SubscriptionType
        },
        paymentMethodType: function() {
            return this.$store.state.authUser.PaymentMethodType
        },
        subscriptionPaymentDetailsPrompt: function() {
            return this.$store.state.authUser.SubscriptionPaymentDetailsPrompt
        },
        subscriptionAnnualCost: function() {
            return config.subscription.annualCost
        },
        subscriptionMonthlyCost: function() {
            return config.subscription.monthlyCost
        },
        showDiscount: function() {
            return this.subscriptionStatus === 'none' && this.discountPlanExists
        },
        discountPlanID: function() {
            return this.$store.state.discountPlanID
        },
        discountPlanMessage: function() {
            return this.$store.state.discountPlanMessage
        },
        discountPlanExists: function() {
            return this.$store.getters.discountPlanExists
        }
    },
    created() {
        this.scrollToTop()
        this.$store.commit('setPageTitle', 'Subscriptions')
        this.$store.commit('setShowHeaderFooter', true)
    },
    beforeDestroy() {
        if (this.dropInInstance) {
            this.dropinInstance.teardown().then(() => {
                this.dropInInstance = null
            })
        }
    }
}
</script>

<style scoped>

div {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-radius: 0.5rem;
    overflow: hidden;
}

.bold-text {
  font-weight: bold
}

.italic-text {
    font-style: italic
}

.dark-green-text {
    color: darkgreen;
}

.dark-red-text {
    color: darkred;
}

.embed-right {
    float: right; 
    max-width: 25%;
    margin: 1.0rem;
    margin-top: 0;
    border-radius: 0.5rem;
    vertical-align: top;
}

.background-two {
    background-color: #ffffff;
}

.background-two {
  background-color: #f9f8f3;
}

</style>



// WEBPACK FOOTER //
// src/components/Subscription.vue